import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import calendar from '../../assets/calendar.svg'
import { useNavigate } from "react-router-dom";
import time from '../../assets/time.svg'
import location from '../../assets/pin.svg'
import foto1 from '../../assets/foto4.png'
import { CSSTransition } from 'react-transition-group';
import { MobileNavbar } from '../NavBar/Mobile/MobileNavbar';
import spinner from '../../assets/spinner.gif'

export const PageSubmitBookingEvent = () => {

    const [detail, setDetail] = useState()
    const [loading, setLoading] = useState(true)
    const [showNavPopup, setShowNavPopup] = useState(false)
    const handleCloseAll = () => {
        setShowNavPopup(false)
    }
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail({nama:"Zidane Dane",prefix:localStorage.getItem('prefix'),phoneNumber:localStorage.getItem('phoneNumber'),namaChef:"Fauzan Pradana", foto:foto1,Type:"Asian",tanggal:localStorage.getItem("tanggal"), jam:localStorage.getItem("jam"),style:localStorage.getItem('style'),pax:localStorage.getItem('pax'), total:localStorage.getItem('total'),address:localStorage.getItem('address'),totalAfter:localStorage.getItem('totalAfter')})
        localStorage.setItem('nav', 'e')
    },[])
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
        }
    },[detail])
    const history = useNavigate()

    

    const handleSeeMyOrder = () => {
        setstandby(false)
        setTimeout(function() {
            history('/MyBooking')
        }, 500);
    }

    
    
    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <MobileNavbar></MobileNavbar>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="SBEPtrans">
                <div className='SBEPkontainer'>
                    <p className='white big bold SBEPtittle'>Thank You</p>
                    <p className='white semibig SBEPtittle'>Your booking has been submitted</p>


                    <div className='SBEPkonten2 flex'>
                        <div className='SBEPkontainerkiri'>
                            <div className='SBEPkontenputih'>
                                <div className='flex' style={{alignItems:""}}>
                                    <div style={{marginRight:"4px"}}>
                                        <p className='bold medium'>Fauzan Pradana</p>
                                        <p className='medium' style={{marginTop:"4px"}}>{detail.prefix} {detail.phoneNumber}</p>
                                    </div>
                                    
                                </div>
                                <div className='flex SBEPmargin'>
                                    <div className='SBEPimage' style={{backgroundImage:`url(${detail.foto})`}}></div>
                                    <div>
                                        <p className='small'>{detail.namaChef}</p>
                                        <p className='small' style={{marginTop:"4px"}}>{detail.Type} Food</p>
                                    </div>
                                </div>
                                <div className='SBEPmargin flex' style={{alignItems:"center"}}>
                                    <img alt="icon" className='SBEPicon' src={calendar}></img>
                                    <p className='small' style={{marginRight:"32px"}}>{detail.tanggal}</p>
                                    <img alt="icon" className='SBEPicon' src={time}></img>
                                    <p className='small' >{detail.jam}</p>
                                </div>
                                <div className='SBEPmargin flex' style={{alignItems:"center"}}>
                                    <img alt="icon" className='SBEPicon' src={location}></img>
                                    <p className='small' >{detail.address}</p>
                                </div>
                            </div>
                        </div>
                        <div className='SBEPkontainerkanan'>
                            <p className='white bold medium'>Invoice Preview</p>
                            <div className='SBEPmargin2 flex'>
                                <p className='small white'>{detail.pax} pax</p>
                                <p className='small white' style={{marginLeft:"auto"}}>IDR {detail.total}</p>
                            </div>
                            <div className='SBEPline SBEPmargin3'></div>
                            <div className='SBEPmargin3 flex'>
                                <p className='small white'>Service Fee</p>
                                <p className='small white' style={{marginLeft:"auto"}}>-</p>
                            </div>
                            <div className='SBEPline SBEPmargin3'></div>
                            <div className='SBEPmargin3 flex'>
                                <p className='small white'>Voucher Ammount</p>
                                <p className='small white' style={{marginLeft:"auto"}}>-</p>
                            </div>

                            <div className='SBEPmargin3 flex'>
                                <p className='small bold white'>Total</p>
                                <p className='small bold white' style={{marginLeft:"auto"}}>IDR {detail.totalAfter}</p>
                            </div>

                            <button onClick={() => handleSeeMyOrder()} className='SBEPbutton small bold SBEPmargin'>Proceed To Payment</button>
                            <button className='SBEPbutton2 small bold SBEPmargin4'>Explore More</button>
                        </div>
                    </div>
                    
                </div>
                </CSSTransition>
            }
        </div>
    )
  }